export default "__VITE_ASSET__DhN00nOd__"